import classNames from 'classnames';
import React from 'react';
import { DOMAIN_PREFIX } from '../../../constants/staticPageConstants';
import { processURL } from '../../../utils/static-pages/urlProcessor';
import { Share } from '../../Calculators/calculator-revamp/components/Share';

export type BREADCRUMB_TYPE = {
  title: string | undefined | string[];
  link: string | null;
};

interface BreadcrumbProps {
  className?: string;
  dataSet?: Array<BREADCRUMB_TYPE> | [];
  text?: string;
  url: string;
  domain: number;
  language: string;
}

const AIBreadcrumb: React.FC<BreadcrumbProps> = (props) => {
  const classes = classNames({
    [`${props.className}`]: !!props.className,
  });

  const pageURL = processURL(props.url, props.language, props.domain);

  const CURR_PAGE_URL = `https://www.${
    DOMAIN_PREFIX[props.domain]?.host
  }/${pageURL}`;
  return (
    <nav
      data-testid="Breadcrumb"
      className={`${classes} bg-grey-light rounded-md w-full flex justify-between`}
    >
      <ol className="list-reset flex flex-row items-center text-s-14 font-medium sm:text-s-14">
        {props.dataSet?.map((ele, index) => {
          const isLastItem = index === (props.dataSet?.length || 0) - 1;
          const isLastSign = index === (props.dataSet?.length || 0) - 2;
          return (
            <>
              <li
                title={
                  Array.isArray(ele.title)
                    ? ele.title.join(', ')
                    : ele.title || 'breadcrumb'
                }
                className={`text-ellipsis whitespace-nowrap overflow-hidden max-w-[300px] lg:max-w-[200px] sm:max-w-[150px] md:max-w-[180px] ${
                  ele.link ? 'text-font-500' : 'text-font-200'
                } ${
                  isLastItem
                    ? ' overflow-hidden whitespace-nowrap text-ellipsis sm:hidden md:hidden'
                    : ''
                }`}
              >
                <a
                  href={ele.link || '#'}
                  className={`${
                    ele.link ? 'text-font-500' : 'text-font-200'
                  } text-s-12 sm:text-s-10 ${
                    isLastItem
                      ? 'overflow-hidden whitespace-nowrap text-ellipsis'
                      : ''
                  }`}
                >
                  {ele.title}
                </a>
              </li>
              {ele.link ? (
                <li>
                  <div
                    className={`p-2 sm:p-0 sm:px-2 sm:pt-1 inline-block align-text-top ${
                      isLastSign ? 'md:hidden sm:hidden' : ''
                    }`}
                  >
                    &gt;
                  </div>
                </li>
              ) : null}
            </>
          );
        })}
      </ol>
      <Share
        url={CURR_PAGE_URL}
        domain={props.domain}
        language={props.language}
      />
    </nav>
  );
};

AIBreadcrumb.defaultProps = {
  dataSet: [{ title: 'Home', link: '/' }],
};

export { AIBreadcrumb };
